import React from "react";
import { Chip, useTheme } from "@mui/material";
import { getStatusChipSx } from "../utils/chipStyles";
import { formatDecisionLabel } from "../utils/constants";

const StatusChip = ({ label }) => {
  const theme = useTheme();
  if (!label) return null;
  const display = formatDecisionLabel(label);

  return (
    <Chip
      label={display}
      variant="filled"
      size="small"
      sx={getStatusChipSx(theme, display)}
    />
  );
};

export default StatusChip;
